import React, { useEffect, useState } from 'react';
import { apiFetch } from '../api';
import EventEditor from './EventEditor';
import EventDetail from './EventDetail';

export default function AdminEvents(){
  const [items, setItems]   = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr]       = useState('');
  const [view, setView]     = useState({ mode: 'list', id: null }); // list | detail | edit

  async function load(){
    try{
      setLoading(true); setErr('');
      const res = await apiFetch('admin/events_list.php');
      const js  = await res.json();
      if (!js.ok) throw new Error(js.error || 'Fehler');
      setItems(js.items || []);
    }catch(e){
      setErr(e.message || 'Laden fehlgeschlagen');
    }finally{
      setLoading(false);
    }
  }

  useEffect(()=>{ load(); }, []);

  if (view.mode === 'edit'){
    return (
      <EventEditor
        id={view.id}
        onCancel={()=>setView({mode:'list', id:null})}
        onSaved={(savedId)=>{
          setView({mode:'list', id:null});
          load();
          // Optional: direkt nach dem Speichern ins Detail springen
          // setView({mode:'detail', id: savedId || view.id});
        }}
      />
    );
  }

  if (view.mode === 'detail'){
    return (
      <EventDetail
        id={view.id}
        onBack={()=>setView({mode:'list', id:null})}
        onEdit={(id)=>setView({mode:'edit', id})}
        onDeleted={()=>{
          setView({mode:'list', id:null});
          load();
        }}
      />
    );
  }

  return (
    <div>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12}}>
        <h2>Events</h2>
        <button className="primary" onClick={()=>setView({mode:'edit', id:0})}>Neues Event</button>
      </div>

      {err && <div className="card" style={{color:'crimson', borderColor:'crimson'}}>{err}</div>}
      {loading && <div className="card">Lade…</div>}

      <div
        className="grid"
        style={{display:'grid', gap:'1rem', gridTemplateColumns:'repeat(auto-fill, minmax(280px,1fr))'}}
      >
        {(items || []).map(it=>(
          <div
            className="card"
            key={it.id}
            style={{cursor:'pointer'}}
            onClick={()=>setView({mode:'detail', id:it.id})}
          >
            <div style={{fontSize:13, opacity:.7}}>{it.slug}</div>
            <div style={{fontWeight:700, fontSize:18}}>{it.title}</div>
            <div style={{marginTop:8, fontSize:13, opacity:.8}}>
              {it.start_at ? `Start: ${it.start_at}` : '—'}
            </div>
            <div style={{display:'flex', justifyContent:'space-between', marginTop:8}}>
              <span>{Number(it.is_published) ? 'Veröffentlicht' : 'Entwurf'}</span>
              <strong>{it.registrations} Anmeldungen</strong>
            </div>
          </div>
        ))}
        {(!items || items.length===0) && !loading && !err && (
          <div className="card" style={{opacity:.8}}>Noch keine Events.</div>
        )}
      </div>
    </div>
  );
}